import React, { useState } from 'react'
import { Row, Col, Card, Button, Upload, Typography, Modal } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import xlsx from 'xlsx'
import Datatable from '../../../component/table/dataTable';
import requester from '../../../lib/requester';
import moment from 'moment';
import FullScreenLoader from '../../../component/loading/FullScreenLoader';
const { Dragger } = Upload;
const { Text } = Typography;

const UploadMultiApprove = () => {
    const [fileXslx, setFileXlsx] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [dataFromBE, setDataFromBE] = useState([])
    const [uploadBatchID, setuploadBatchID] = useState('')
    const [message, setMessage] = useState('')
    const [totalRows, setTotalRows] = useState(0)
    const [totalNotesFilled, setTotalNotesFilled] = useState(0)
    const [totalNotesEmpty, setTotalNotesEmpty] = useState(0)

    const handleXlsx = async (e) => {
        const f = e.file.originFileObj;
        const reader = new FileReader();
        let formData = new FormData();
        formData.append("fileUpload", f);
        reader.onload = async (e) => {
            var data = e.target.result;
            let readedData = xlsx.read(data, {
                type: "binary",
                cellDates: true,
                cellNF: false,
                cellText: false,
            });
            const wsname = readedData.SheetNames[0];
            const ws = readedData.Sheets[wsname];
            const dataExcel = xlsx.utils.sheet_to_json(ws, {
                header: 0,
                raw: true,
                defval: null,
            });
            const array1 = {
                "APPROVE": "",
                "REVISE": "",
                "REJECT": "",
                "REASON": "",
                "CLAIM NUMBER": ""
            };

            function hasAllElements(arr1, arr2) {
                for (const key in arr1) {
                    if (!arr2.some(obj => obj.hasOwnProperty(key))) {
                        return false;
                    }
                }
                return true;
            }

            if (hasAllElements(array1, dataExcel)) {
                const newMap = dataExcel.map((value) => {
                    return {
                        "notes": '',
                        "approve": value["APPROVE"],
                        "revise": value["REVISE"],
                        "reject": value["REJECT"],
                        "reason": value["REASON"],
                        "cover_letter_no": value["COVER LETTER NO"],
                        "claim_number": value["CLAIM NUMBER"],
                        "ref_no": value["REF NO"],
                        "customer_name": value["CUSTOMER NAME"],
                        "program_type": value["PROGRAM TYPE"],
                        "dpp": value["DPP"],
                        "ppn": value["PPN"],
                        "total_claim": value["TOTAL CLAIM"],
                        "pph_rate": value["PPH RATE"],
                        "pph": value["PPH"],
                        "nett_claim": value["NET CLAIM"],
                    }
                })
                pushToApi(newMap)
            } else {
                setTotalRows(0)
                setTotalNotesFilled(0)
                setTotalNotesEmpty(0)
                setDataFromBE([])
                setFileXlsx(null)
                error("Failed. Make sure the excel template that is uploaded matches the guidelines")
            }

        }
        reader.readAsBinaryString(f)
    }

    const pushToApi = async (data) => {
        setTotalRows(0)
        setTotalNotesFilled(0)
        setTotalNotesEmpty(0)
        setDataFromBE([])
        setIsLoading(true)
        const url = '/api/traces/v1/claim/multiapprove/upload'

        try {
            await requester.postTraces(url, data, {
                success: function (response) {
                    const mes = response.data.message
                    const res = response.data.data.validatedData;
                    const id = response.data.data.uploadBatchID
                    const status = response.data.status

                    setuploadBatchID(id)
                    calculate(res)
                    setIsLoading(false)
                    setDataFromBE(res)
                    setMessage(mes)
                    if (status) {
                        success(mes, 'api')
                    } else {
                        error(mes)
                        setIsLoading(false)
                    }
                },
                error: function (e) {
                    error("ERROR. Failed upload xlsx")
                    setIsLoading(false)
                    setMessage("ERROR. Failed upload xlsx")
                },
            });
        } catch (error) {
            setIsLoading(false)
        }
    }

    const calculate = (data) => {
        let rows = data.length;
        let notesFilled = 0;
        let notesEmpty = 0;

        for (const item of data) {
            if (item.notes !== '' && item.notes !== null && item.notes !== undefined) {
                notesFilled++;
            } else {
                notesEmpty++;
            }
        }

        // Mengupdate state dengan nilai yang dihitung
        setTotalRows(rows);
        setTotalNotesFilled(notesFilled);
        setTotalNotesEmpty(notesEmpty);
    }

    const handleSubmit = async () => {
        const url = '/api/traces/v1/claim/multiapprove/upload/submit'
        const data = new FormData();
        data.append("uploadBatchID", uploadBatchID);
        data.append('fileUpload', fileXslx.originFileObj, fileXslx.name);
        setIsLoading(true)

        try {
            requester.postnobodyTraces(url, data, {
                success: function (response) {

                    const mes = response.data.message
                    const status = response.data.status

                    setIsLoading(false)
                    if (status === false) {
                        const res = response.data.data.validatedData;
                        error(mes)
                        calculate(res)
                        setDataFromBE(res)
                    } else {
                        success(mes, 'submit')
                        setTotalRows(0)
                        setTotalNotesFilled(0)
                        setTotalNotesEmpty(0)
                        setDataFromBE([])
                        setFileXlsx(null)
                    }
                },
                error: function (e) {
                    error("Failed")
                    setIsLoading(false)
                },
            });
        } catch (error) {
            setIsLoading(false)
            error("Failed")
        }
    }

    const validate = () => {
        let valid = true

        if (!fileXslx) {
            valid = false
        }
        if (totalNotesFilled) {
            valid = false
        }
        return valid
    }

    const success = (mes, from) => {
        Modal.success({
            content: (
                <>
                    <p>
                        {mes}
                    </p>
                </>
            ),
            zIndex: 1004,
            onOk: () => {
                if (from === 'submit') {
                    window.location.reload()
                }
            }
        });
    };

    const error = (error) => {
        Modal.error({
            content: (
                <>
                    <p>
                        {error}
                    </p>
                </>
            ),
            zIndex: 1004,
            onOk: () => {
                // submit(dataToSubmit) 
            }
        });
    };

    const exportToXlsx = () => {
        const newMap = dataFromBE && dataFromBE.length ? dataFromBE.map((value, index) => {
            return {
                "NOTES": value.notes,
                "APPROVE": value.approve,
                "REVISE": value.revise,
                "REJECT": value.reject,
                "REASON": value.reason,
                "COVER LETTER NO": value.cover_letter_no,
                "CLAIM NUMBER": value.claim_number,
                "REF NO": value.ref_no,
                "CUSTOMER NAME": value.customer_name,
                "PROGRAM TYPE": value.program_type,
                "DPP": value.dpp,
                "PPN": value.ppn,
                "TOTAL CLAIM": value.total_claim,
                "PPH RATE": value.pph_rate,
                "PPH": value.pph,
                "NET CLAIM": value.nett_claim,
            }
        }) : []

        const workBook = xlsx.utils.book_new(); // create a new blank book
        const workSheet = xlsx.utils.json_to_sheet(newMap);
        xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
        xlsx.writeFile(workBook, "Data upload multi approval.xlsx"); // initiate a file download in browser
    }
    return (
        <>
            <Card>
                <Row gutter={34}>
                    <Col span={10}>
                        <Dragger
                            name="xlsx"
                            fileList={[]}
                            multiple={false}
                            customRequest={() => false}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={(info) => {
                                handleXlsx(info)
                                setFileXlsx(info.file)
                            }}
                            showUploadList={false}
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                                DRAG AND DROP MULTI APPROVAL FILE
                                <span className="text-danger">*</span>
                            </p>
                            <p className="ant-upload-hint">
                                Supported File : Excel File Only (.xlsx, .xls)
                            </p>
                        </Dragger>
                    </Col>
                    <Col span={14}>
                        <Card style={{ display: `${fileXslx ? 'grid' : 'none'}` }}>
                            <p>Upload Result</p>
                            <div>
                                <p>
                                    <b>Total : {totalRows} Row(s) </b>
                                    {' | '}
                                    <b className='text-success'>Success : {totalNotesEmpty} Row(s) </b>
                                    {' | '}
                                    <b className='text-danger'>Failed : {totalNotesFilled} Row(s)</b>
                                </p>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <Button
                                    onClick={() => exportToXlsx()}
                                    className='m-2'
                                    style={{ background: '#52c41a', color: 'white' }}
                                    type='success' block>Export to xlsx</Button>
                                <Button
                                    onClick={() => setFileXlsx(null)}
                                    className='m-2' type='primary' block>Cancel</Button>
                                <Button
                                    onClick={() => handleSubmit()}
                                    disabled={!validate()}
                                    className='m-2'
                                    type='primary'
                                    block>Submit</Button>
                            </div>
                        </Card>
                        <Text style={{ display: `${fileXslx ? 'grid' : 'none'}` }} type="secondary">File name : {fileXslx ? fileXslx.originFileObj.name : ''}</Text>
                    </Col>
                </Row>
            </Card>
            <Card style={{ display: `${fileXslx ? 'block' : 'none'}` }}>
                <Datatable data={dataFromBE} />
            </Card>
            <FullScreenLoader isLoading={isLoading} />
        </>
    )
}

export default UploadMultiApprove